export default "__VITE_ASSET__C$8aaRTO__"